<div class="basket-confirmation">
  <button class="close" (click)="dismiss()" title="{{ 'generic.close' | translate }}" [attr.aria-label]="'generic.close' | translate">
    <span class="icon-view-close" aria-hidden="true">
      <svg>
        <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
      </svg>
    </span>
  </button>

  <div class="header">
    <span class="icon-success" aria-hidden="true">
      <svg>
        <use xlink:href="assets/img/icons.svg#icon-action-success"></use>
      </svg>
    </span>
    <h2 class="title">{{ '2d-configurator.basket-confirmation.title' | translate }}</h2>
  </div>

  <p class="project-name">{{ projectName }}</p>
  <p class="total-amount">{{ totalAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</p>

  @if (redirectError) {
    <p class="redirect-error">{{ '2d-configurator.basket-confirmation.redirect-error' | translate }}</p>
  }

  <div class="actions">
    <ng-casto-button
      class="secondary"
      [label]="'2d-configurator.basket-confirmation.back-to-project' | translate"
      (click)="backToProject()"></ng-casto-button>
    <ng-casto-button
      class="primary"
      [label]="'2d-configurator.basket-confirmation.see-basket' | translate"
      (click)="seeBasket()"></ng-casto-button>
  </div>
</div>
